module.exports = __webpack_public_path__ + "img/newsletters_send.0ef2c95b.jpg";